var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dynamic-input',{attrs:{"input":_vm.input,"fields":_vm.fields,"disabled":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }